module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-02.bfc32d55.jpg";